
import { Button } from "@/components/ui/button";

interface AgentSourceToggleProps {
  agentSource: "local" | "elevenlabs";
  setAgentSource: (source: "local" | "elevenlabs") => void;
}

const AgentSourceToggle = ({ agentSource, setAgentSource }: AgentSourceToggleProps) => {
  return (
    <div className="flex space-x-4">
      <Button 
        variant={agentSource === "elevenlabs" ? "default" : "outline"} 
        size="sm"
        onClick={() => setAgentSource("elevenlabs")}
      >
        ElevenLabs Agents
      </Button>
      <Button 
        variant={agentSource === "local" ? "default" : "outline"} 
        size="sm"
        onClick={() => setAgentSource("local")}
      >
        Local Agents
      </Button>
    </div>
  );
};

export default AgentSourceToggle;
